import { forwardRef, useImperativeHandle, useState } from "react";
import IC_COLLECTOR_CLOSE from "@/assets/common/ic_collect_close.svg?react";
import ReactDOM from "react-dom";
import { RuningInLink } from "@/constants";
import LinkNoMessageHelp from "./LinkNoMessageHelp";
import WebNoMessageHelp from "./WebNoMessageHelp";

interface NoMessageHelpModalProps {}

export interface NoMessageHelpModalRef {
  open: () => void;
  close: () => void;
}

const NoMessageHelpModal = forwardRef<
  NoMessageHelpModalRef,
  NoMessageHelpModalProps
>((_props, ref) => {
  const [visible, setVisible] = useState(false);
  const onClose = () => {
    setVisible(false);
  };

  useImperativeHandle(ref, () => ({
    open: () => {
      setVisible(true);
    },
    close: onClose,
  }));

  return visible
    ? ReactDOM.createPortal(
        <div
          className={`fixed w-full h-full inset-0 flex items-center justify-center z-999 bg-black bg-opacity-50`}
        >
          <div className="flex flex-col bg-white w-105 h-121.5 rounded-4 shadow relative overflow-hidden">
            <div className="text-center h-12 relative">
              <div className="lh-12 absolute left-0 right-0 m-auto text-4 font-500 text-mx-secondary cursor-default">常见原因</div>
              <IC_COLLECTOR_CLOSE className="w-6 h-6 absolute top-3 right-3 cursor-pointer" onClick={onClose} />
              <div className="absolute bottom-0 bg-#ECEEF3 w-full h-1px"></div>
            </div>
            <div className="flex-1 mx-1.5 mt-8 pb-8 overflow-x-hidden overflow-y-auto my-scrollbar">
            {RuningInLink ? <LinkNoMessageHelp /> : <WebNoMessageHelp />}
            </div>
          </div>
        </div>,
        document.body
      )
    : null;
});

export default NoMessageHelpModal;
